import React from 'react';
import HeaderExpanded from "./HeaderExpanded";
import SensorValue from "./SensorValue";
import {withStyles} from "@material-ui/core/styles";
import Offline from "./Offline";
import clsx from "clsx";

const styles = theme => ({
    root: {},
    sensorsContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        background: theme.palette.common.white,
        overflow: 'hidden'
    },
    footer: {
        borderBottomLeftRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
    },
    sensor: {
        flex: '1 0 20%',
        boxSizing: 'border-box',
        borderBottom: [[1, 'solid', theme.palette.divider]],
        borderRight: [[1, 'solid', theme.palette.divider]]
    },
});

const sensors = [
    'iaq', 'temp', 'humi', 'sound', 'press', 'co2', 'voc', 'ch4', 'no2', 'co'
];

const DeviceExpanded = ({classes, realTime, room, model, status, color, ...props}) => {
    const online = realTime && realTime.status === 'online';

    return (
        <div className={classes.root}>
            <HeaderExpanded
                room={room}
                model={model}
                status={status}
                color={color}
            />

            {!online && (
                <Offline className={classes.footer} expanded realTime={realTime} />
            )}

            {online && (
                <div className={clsx(classes.sensorsContainer, classes.footer)}>
                    {sensors.map(sensor => (
                        <SensorValue
                            key={sensor}
                            className={classes.sensor}
                            sensorTypeName={sensor}
                            value={realTime[sensor]}
                            withSensorTypeName
                            withDots
                        />
                    ))}
                </div>
            )}

        </div>
    );
};

DeviceExpanded.propTypes = {};

export default withStyles(styles)(DeviceExpanded);
